import { MOCK_CHATBOTS } from '../../mock/fixtures';
import type { Chatbot } from '../../mock/fixtures';
import { mockRequest } from '../../mock/transport';

/**
 * Truy cập dữ liệu chatbot.
 *
 * Khi có API thật, chỉ tệp này đổi: `mockRequest` thay bằng lệnh gọi HTTP qua
 * gateway. View và hook không phải sửa gì (§14.5).
 */
export const chatbotRepository = {
  list: (): Promise<Chatbot[]> => mockRequest(MOCK_CHATBOTS, []),
};
